import type { Campaign } from '@/api/types/graphql';

export const findVariantByOrigin = (campaign: Campaign | undefined, isOrigin: boolean) => {
  return campaign?.variants?.find((v) => v?.isOrigin === isOrigin);
};
